import { memo } from 'react';
import { IconProps } from './iconType';

export const EdtiIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
      <path
        d="M18 2C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V6.757L10 15.757L9.995 20H14.241L19 15.242V21C19 21.2652 18.8946 21.5196 18.7071 21.7071C18.5196 21.8946 18.2652 22 18 22H2C1.73478 22 1.48043 21.8946 1.29289 21.7071C1.10536 21.5196 1 21.2652 1 21V3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2H18ZM19.778 8.808L21.192 10.222L13.414 18H12V16.588L19.778 8.808ZM10 12H5V14H10V12ZM13 8H5V10H13V8Z"
        fill={color}
      />
    </svg>
  );
});

EdtiIcon.displayName = 'EdtiIcon';
